import { ReactElement } from 'react';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';
import { Practitioner, ReservationPreference } from '@dreryk/egabinet-waitlist-frontend-api';

import { StyledFlex, TextView } from '@dreryk/react-components';
import { createSingleInterpolatedTranslationKey } from '@dreryk/react-common';

import { formatPractitioner } from '../../shared/formatPractitioner';
import { translationKeys } from '../../translations';

import { IncompatiblePreferenceNotification } from './IncompatiblePreferenceNotification';

type PractitionerTextViewProps = {
   appointmentPractitioner: AppointmentPractitioner;
   practitioner: Practitioner;
   reservationPreference: ReservationPreference;
};

export const PractitionerTextView = (props: PractitionerTextViewProps): ReactElement => {
   const priority = props.reservationPreference === 'PRACTITIONER';
   const formattedAppointmentPractitioner = formatPractitioner(props.appointmentPractitioner);
   const formattedWaitlistPractitioner = formatPractitioner(props.practitioner);
   const shouldShowNotification = Boolean(
      props.appointmentPractitioner && props.appointmentPractitioner.id.asNumber() !== props.practitioner.id.asNumber()
   );

   return (
      <TextView testId={'specialist'} label={translationKeys.specialist}>
         <StyledFlex direction={'column'} gap={'8px'}>
            {formattedAppointmentPractitioner}
            {shouldShowNotification ? (
               <IncompatiblePreferenceNotification
                  testId={'practitionerPreference'}
                  warning={priority}
                  label={createSingleInterpolatedTranslationKey(
                     priority ? translationKeys.priorityPreference : translationKeys.preference,
                     'label',
                     formattedWaitlistPractitioner
                  )}
               />
            ) : null}
         </StyledFlex>
      </TextView>
   );
};
